import { render } from "./activityList.vue?vue&type=template&id=8965f2f6&ts=true"
import script from "./activityList.vue?vue&type=script&lang=ts"
export * from "./activityList.vue?vue&type=script&lang=ts"

import "./activityList.vue?vue&type=style&index=0&id=8965f2f6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__